export default class extends Controller {
  static targets = ['toggle', 'fieldsContainer'];

  connect() {
    this.hideOrShowFields();
  }

  hideOrShowFields() {
    this.showFields = this.fieldsShouldShow;
  }

  //
  // GETTERS AND SETTERS
  //

  get fieldsShouldShow() {
    return this.toggleTarget.checked;
  }

  set showFields(val) {
    App.Helpers[`${val ? 'show' : 'hide'}Element`](this.fieldsContainerTarget);
  }
};



// WEBPACK FOOTER //
// ./app/components/forms/fields/assets/javascript/toggle-fields-controller.js